const DRAG_THRESHOLD = 6;
const RAIL_SELECTOR = '.splide__list';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const arrowIcon = (direction) =>
  `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${direction === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6'}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const isRail = (element) => element?.matches(RAIL_SELECTOR) && element.querySelector(':scope > .card-product');

class SkyaProductRail {
  constructor(section) {
    this.section = section;
    this.label = section.querySelector('h2')?.textContent.trim() || '';
    this.drag = null;
    this.activeRail = null;
    this.renderControls();
    this.bindDrag();
    this.bindKeyboard();
    section.addEventListener('scroll', () => this.update(), { capture: true, passive: true });
    window.addEventListener('resize', () => this.update());
    new MutationObserver(() => this.refresh()).observe(section, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    this.refresh();
  }

  rails() {
    return [...this.section.querySelectorAll(RAIL_SELECTOR)].filter(isRail);
  }

  currentRail() {
    return this.rails().find((rail) => rail.offsetParent !== null);
  }

  refresh() {
    this.rails().forEach((rail) => {
      if (rail.dataset.skyaRail) return;
      rail.dataset.skyaRail = 'true';
      rail.setAttribute('tabindex', '0');
      rail.setAttribute('role', 'region');
      rail.setAttribute('aria-label', this.label);
    });
    const rail = this.currentRail();
    if (rail && rail !== this.activeRail) {
      this.activeRail = rail;
      rail.scrollLeft = 0;
    }
    this.update();
  }

  renderControls() {
    this.controls = document.createElement('div');
    this.controls.className = 'skya-rail-controls';
    this.controls.innerHTML = `
      <button type="button" data-direction="-1" aria-label="Produsele anterioare">${arrowIcon('prev')}</button>
      <button type="button" data-direction="1" aria-label="Produsele următoare">${arrowIcon('next')}</button>`;
    this.section.querySelector('.x-block-header')?.appendChild(this.controls);
    [this.prev, this.next] = this.controls.querySelectorAll('button');
    this.controls.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      const rail = this.currentRail();
      if (button && rail) this.step(rail, Number(button.dataset.direction));
    });
  }

  update() {
    const rail = this.currentRail();
    if (!rail) return;
    const maxScroll = rail.scrollWidth - rail.clientWidth - 1;
    this.controls.classList.toggle('is-hidden', maxScroll <= 0);
    this.prev.disabled = rail.scrollLeft <= 0;
    this.next.disabled = rail.scrollLeft >= maxScroll;
  }

  step(rail, direction) {
    const card = rail.querySelector(':scope > .card-product');
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    rail.scrollBy({ left: direction * distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }

  bindKeyboard() {
    this.section.addEventListener('keydown', (event) => {
      if (!isRail(event.target) || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.step(event.target, event.key === 'ArrowRight' ? 1 : -1);
    });
  }

  bindDrag() {
    this.section.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      const rail = event.target.closest(RAIL_SELECTOR);
      if (!isRail(rail)) return;
      this.drag = { rail, pointerId: event.pointerId, startX: event.clientX, startScroll: rail.scrollLeft, moved: false };
    });

    this.section.addEventListener('pointermove', (event) => {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;
      const delta = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(delta) < DRAG_THRESHOLD) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.rail.classList.add('is-dragging');
        drag.rail.setPointerCapture(drag.pointerId);
      }
      drag.rail.scrollLeft = drag.startScroll - delta;
    });

    const endDrag = (event) => {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;
      this.drag = null;
      if (!drag.moved) return;
      drag.rail.classList.remove('is-dragging');
      drag.rail.addEventListener('click', (click) => {
        click.preventDefault();
        click.stopPropagation();
      }, { capture: true, once: true });
    };

    this.section.addEventListener('pointerup', endDrag);
    this.section.addEventListener('pointercancel', endDrag);
    this.section.addEventListener('dragstart', (event) => {
      if (event.target.closest(RAIL_SELECTOR)) event.preventDefault();
    });
  }
}

document.querySelectorAll('.theme-template-index .section-featured-collection').forEach((section) => new SkyaProductRail(section));
